import { render, staticRenderFns } from "./headerNativation.vue?vue&type=template&id=6ee3878c&scoped=true&"
import script from "./headerNativation.vue?vue&type=script&lang=js&"
export * from "./headerNativation.vue?vue&type=script&lang=js&"
import style0 from "./headerNativation.vue?vue&type=style&index=0&id=6ee3878c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee3878c",
  null
  
)

export default component.exports